export default __webpack_public_path__ + "static/generative-border-colors-light-94528f648fbf3a9ce8e970d2347f33c34eca1128158648fa5c86faa45a8b7b39.png";